import React from "react";
import { useSelector } from "react-redux";
import { actionCreators } from "./redux/membershipSagas";
import SectionContainer from "../../../components/sectionContainer/sectionContainer";
import MembershipSales from "./smartComponents/membershipSales";
import Members from "./smartComponents/members";
import NewMemberships from "./smartComponents/newMembers";
import ZeroVisitMembers from "./smartComponents/zeroVisitMembers";
import ExpiredMembershipsContacts from "./smartComponents/expiredMembershipsContacts";
import YearOverYearMembershipRevenue from "./smartComponents/yearOverYearMembershipRevenue";
import FrozenMembers from "./smartComponents/frozenMembers";
import SectionToggle from "../../../components/sectionToggle/sectionToggle";
import MembershipLearnMore from "./smartComponents/membershipLearnMore";
import styles from "./membership.module.css";
import { useFetchData } from "../hooks/dataFetchingHooks";

const MembershipModule = (props) => {
  useFetchData({
    moduleName: "membership",
    props,
    fetchData: actionCreators.fetchCurrentUser,
    updateData: actionCreators.updateAllData
  });

  let { hideMembers, hideNewMembers, hideMembersAtRisk, hideFrozenMembers } = props;
  const isLoading = useSelector((state) => state.membership.isLoading);
  const frozenMembers = useSelector((state) => state.membership.frozenMembers);

  const renderYoYRevenue = () => {
    return (
      <>
        <SectionContainer title="Membership Revenue">
          <YearOverYearMembershipRevenue />
        </SectionContainer>
      </>
    );
  };

  const renderMembers = () => {
    let memberMetrics = (
      <>
        <div className={styles.metrics}>
          <SectionContainer title="Membership Sales">
            <MembershipSales />
          </SectionContainer>
        </div>
        {!hideMembers && (
          <div className={styles.metrics}>
            <Members />
          </div>
        )}

        {!hideNewMembers && (
          <div className={styles.metrics}>
            <NewMemberships />
          </div>
        )}

        {!hideFrozenMembers && !!Object.keys(frozenMembers.totalFrozen).length && (
          <div className={styles.metrics}>
            <FrozenMembers />
          </div>
        )}
      </>
    );

    return (
      <div className="flex flex-col">
        <div className={`${styles.memberMetrics} flex flex-wrap`}>{memberMetrics}</div>
        {hideMembersAtRisk ? null : renderYoYRevenue()}
      </div>
    );
  };
  const renderYoYRevenueOrRiskMembers = () => {
    return (
      <>
        {!props.hideZeroVisitsMembers && (
          <SectionContainer title="Zero Visit Members">
            <ZeroVisitMembers />
          </SectionContainer>
        )}
        {!hideMembersAtRisk ? <ExpiredMembershipsContacts /> : <div>{renderYoYRevenue()}</div>}
      </>
    );
  };

  return (
    <SectionToggle
      autoHeight
      title="Membership"
      learnMore={<MembershipLearnMore {...props.learnMore} />}
      customClass="membershipWidget"
      height={0}
      isLoading={isLoading}
      content={
        <div className="flex">
          <div className={styles.sectionGroup}>{renderMembers()}</div>
          <div className={styles.sectionGroup}>{renderYoYRevenueOrRiskMembers()}</div>
        </div>
      }
    />
  );
};

export default MembershipModule;
